import React from 'react';
import shortid from 'shortid';

const DefaultTypeArray = props => {
  const { children, schema, path = [] } = props;
  return (
    <div className={`default-type-array depth-${path.length}`}>
      {schema.title && (
        <div className="default-type-array-title">
          <strong className="default-type-title">{schema.title}</strong>
        </div>
      )}
      <div className="default-type-array-children">
        {children.map((child, idx) => (
          <div key={shortid.generate()} className="default-type-array-item">
            {schema && schema.items && schema.items.title && (
              <div className="default-type-array-item-title">
                <strong className="default-type-title">
                  {`${schema.items.title} ${idx + 1}`}
                </strong>
              </div>
            )}
            <div className="default-type-array-item-value">{child}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DefaultTypeArray;
